module.exports = __webpack_public_path__ + "img/icone-redondo-azul.ee601b48.png";